export default __webpack_public_path__ + "static/ibrar_MEAN_MERN_Stack-7737bcaa95c5679a5f5bc295b6f8c087.pdf";